import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { scarcity } from '../data/site';
export function ScarcityBar() {
  const filled = Math.round((scarcity.total - scarcity.remaining) / scarcity.total * 100);
  return <div className="mx-auto w-full max-w-xl rounded-2xl border-2 border-danger/30 bg-red-50 p-4" data-id="element-54" data-mp="2l33ho7kq3uuv">
      <div className="mb-2 flex items-center justify-between gap-2" data-id="element-55" data-mp="2q1o6lauiys40">
        <p className="flex items-center gap-1.5 text-sm font-extrabold text-danger sm:text-base" data-id="element-56" data-mp="2b56xyrdpzrl5">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-57" data-mp="2g7efrxl8e1ve" />
          Only {scarcity.remaining} spots left at $27
        </p>
        <span className="text-sm font-black text-danger" data-id="element-58" data-mp="27555n8tvkaij">{filled}%</span>
      </div>
      <div className="h-4 w-full overflow-hidden rounded-full bg-red-200" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-59" data-mp="27798dng1f3h8">
        <motion.div className="h-full rounded-full bg-danger" initial={{
        width: '40%'
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-60" data-mp="5bpe89pyqrmi" />
      </div>
      <p className="mt-2 text-xs font-medium text-red-900/80" data-id="element-61" data-mp="3dc6ei21x27ri">Once these spots are claimed, the promotional price closes.</p>
    </div>;
}